import { render, staticRenderFns } from "./LegacyAccountNoticeModal.vue?vue&type=template&id=377c13c4&scoped=true&"
import script from "./LegacyAccountNoticeModal.vue?vue&type=script&lang=ts&"
export * from "./LegacyAccountNoticeModal.vue?vue&type=script&lang=ts&"
import style0 from "./LegacyAccountNoticeModal.vue?vue&type=style&index=0&id=377c13c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377c13c4",
  null
  
)

export default component.exports